<template>

  <form class="form normal entry" @submit.prevent="handleSubmit">

    <div class="left-section">

      <div>

        <Logo class="mobile" />

         <Logo :logoOverride="logo2" class="desktop" />

      </div>

    </div><div class="wrap">

      <div class="wrap-wrap">

        <div class="wrap-wrap-wrap">

      <h2 class="form-section-title">Reset your password</h2>

      <FormInput type="email" v-model="email" name="email" placeholder="Your email address" :errors="errors" @has-internal-errors="hasInternalErrors" />

      <p 
        class="error" 
        v-if="typeof errors === 'string' && errors !== ''" 
        v-html="errors" 
      />

      <input type="submit" value="Reset">

      <router-link to="/login" v-html="'Login'" />

    </div></div></div>

  </form>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import ApiService from './../services/api.service'
import FormInput from './../components/Form/Input.vue'
import Logo from './../components/Logo.vue'
export default {
  name: "ForgotPassword",
  components: {
    FormInput,
    Logo
  },
  data() {
    return {
      email: "",
      errors: {},
      inputErrors: {},
      okToSubmit: true
    }
  },
  computed: {

    ...mapState('general',['logo2'])

  },
  methods: {
      ...mapMutations('general',['updateLoadingText']),
      handleSubmit() {

          this.errors = {};

          if ( this.okToSubmit && this.email !== '' ) {

            this.updateLoadingText('One moment...');

            ApiService.post( 'users/forgot-password', { email: this.email } )
            .then( function( response ) {
              
              this.errors = response.data;

              this.updateLoadingText();

            }.bind(this))
            .catch( function(error) {

              Vue.set(this, 'errors', error.response.data.error);
              this.updateLoadingText();

            }.bind(this));

          }
      },
       hasInternalErrors(a) {
        this.inputErrors[a.name] = a.error;
        this.okToSubmit = true
        Object.keys(this.inputErrors).forEach( function (n) {

          if ( this.inputErrors[n].error ) {

            this.okToSubmit = false;

          }

        }.bind(this));
      }
  }
};
</script>